import { Modal, Select } from 'antd';
import { ProjectReportType } from 'constants/project';
import { useReportLanguage } from 'hooks';
import { useTranslation } from 'react-i18next';
import { supportedLanguages } from 'utils/i18n';

type ReportLanguageModalProps = {
  projectId: number
  reportType?: ProjectReportType;
  open: boolean;
  setOpen: (bool: boolean) => void;
  onOk: (downloadDTo : { projectId: number, type?: ProjectReportType, language?: string }) => void;
  isFetching?: boolean;
}

const ReportLanguageModal = ({ projectId, reportType, open, setOpen, onOk, isFetching }: ReportLanguageModalProps) => {
  const { t } = useTranslation();
  const { lang, setLanguage, isReady } = useReportLanguage();

  if (!isReady) return null;

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      okButtonProps={{
        onClick: () => {
          onOk({ projectId: projectId, type: reportType, language: lang });
          setOpen(false);
        },
        loading: isFetching
      }
      }
      title={t('entities.project.languageselection')}
    >
      <Select
        defaultValue={lang}
        style={{ width: '100%', maxWidth: 'none' }}
        onChange={(value) => setLanguage(value)}
      >
        <Select.Option value={supportedLanguages.FI.abrevation}>{t('common.languages.finnish')}</Select.Option>
        <Select.Option value={supportedLanguages.EN.abrevation}>{t('common.languages.english')}</Select.Option>
      </Select>
    </Modal>
  );
};

export default ReportLanguageModal;